import React from 'react';

const GameIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.33219 9.99998L12.0455 12.856C12.274 13.0964 12.5743 13.2563 12.9014 13.3116C13.2285 13.3669 13.5646 13.3146 13.8595 13.1626C14.1543 13.0107 14.3919 12.7672 14.5367 12.4687C14.6814 12.1703 14.7254 11.8329 14.6622 11.5073L13.5955 6.01932M5.33219 5.99998V7.33331M4.66553 6.66665H5.99886M9.33219 6.66665H10.6655M10.3322 3.33331C11.2162 3.33331 12.0641 3.6845 12.6892 4.30962C13.3143 4.93475 13.6655 5.78259 13.6655 6.66665C13.6655 7.5507 13.3143 8.39855 12.6892 9.02367C12.0641 9.64879 11.2162 9.99998 10.3322 9.99998H6.66553L3.98886 12.818C3.7599 13.059 3.45879 13.2192 3.13091 13.2742C2.80304 13.3292 2.46615 13.2762 2.17103 13.1231C1.87591 12.97 1.63854 12.7252 1.4947 12.4254C1.35085 12.1257 1.30833 11.7873 1.37352 11.4613L2.46286 6.01265C2.61406 5.25695 3.02245 4.577 3.61852 4.0885C4.21459 3.6 4.96152 3.33313 5.73219 3.33331H10.3322Z",
      stroke: "#185A67",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
GameIcon.displayName = "Icons.GameIcon";

export { GameIcon };
//# sourceMappingURL=GameIcon.js.map
